import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { Session } from '@supabase/supabase-js'
export interface IUserAuthState {
  session: Session | null
  isUserAuthEventPasswordRecovery: boolean
  isUserAuthSuccess: boolean
}

const initialState: IUserAuthState = {
  session: null,
  isUserAuthEventPasswordRecovery: false,
  isUserAuthSuccess: false
}

const userAuthSlice = createSlice({
  name: 'userAuth',
  initialState,
  reducers: {
    setSession: (state, action: PayloadAction<Session | null>) => {
      state.session = action.payload
    },
    setUserAuthEventPasswordRecovery: (
      state,
      action: PayloadAction<boolean>
    ) => {
      state.isUserAuthEventPasswordRecovery = action.payload
    },
    setUserAuthSuccess: (state, action: PayloadAction<boolean>) => {
      state.isUserAuthSuccess = action.payload
    },
    clearUserAuth: () => {
      return initialState
    }
  }
})

export const {
  setSession,
  setUserAuthEventPasswordRecovery,
  setUserAuthSuccess,
  clearUserAuth
} = userAuthSlice.actions
export default userAuthSlice.reducer
